import { useEffect, useRef } from 'react';
import { CheckboxProps } from './checkbox.interface';
import * as S from './checkbox.styles';

const Checkbox = ({ label, onChange, name, checked, className, disabled }: CheckboxProps) => {
  const checkboxRef = useRef<any>();

  useEffect(() => {
    if (checked) {
      checkboxRef.current.checked = true;
    }
  });

  const handleChange = (e: any) => {
    if (onChange) onChange(e, name);
  };
  return (
    <S.CheckBox className={className}>
      <input name={name} type="checkbox" onChange={handleChange} disabled={disabled} />
      <div className="checkmark">
        <div className="mark"></div>
      </div>
      <S.Lable>{label}</S.Lable>
    </S.CheckBox>
  );
};

export default Checkbox;
